/**
 * Sprint 65 — Nombre de calle a partir de unas coordenadas (Nominatim / OpenStreetMap).
 *
 * Estaba dentro de `MapaPicker` y ahora lo necesita también el campo de dirección: cuando el
 * operador pega el enlace que le mandó el cliente por WhatsApp, lo que hay que guardar es una
 * dirección que el repartidor pueda leer —no la URL—.
 *
 * Sin API key y sin Google (ADR "cero Google Maps"). Nominatim pide cortesía: 1 req/s y un
 * `User-Agent` identificable; se usa sólo cuando el operador hace algo, nunca en bucle.
 *
 * Devuelve `null` en cualquier fallo. Que no haya internet no puede impedir tomar el pedido:
 * las coordenadas ya se guardaron y con ésas el repartidor llega igual.
 */
export async function geocodeInverso(lat: number, lng: number): Promise<string | null> {
  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`,
      { headers: { 'Accept-Language': 'es' } },
    );
    if (!res.ok) return null;
    const j = (await res.json()) as { display_name?: string };
    return j.display_name ?? null;
  } catch {
    return null;
  }
}
